import apiClient from './api.ts';
import {
  SchoolRegistrationRequest,
  SchoolRegistrationResponse,
  TrialRequest,
  SubscriptionPlan,
  SchoolSubscription,
  SchoolSubscriptionResponse,
  SubscriptionUsage,
  PlanChangeRequest,
  AutoRenewRequest
} from '@/types/subscription_schema.ts';
import { AxiosResponse } from 'axios';

export default {
  // School Registration
  async registerSchool(registration: SchoolRegistrationRequest): Promise<AxiosResponse<{data: SchoolRegistrationResponse}>> {
    return await apiClient.post('auth/register/school', registration);
  },

  // Subscription Plans
  async getSubscriptionPlans(): Promise<AxiosResponse<{data: SubscriptionPlan[]}>> {
    return await apiClient.get('/subscription-plans');
  },

  // Trial Management
  async startFreeTrial(request: TrialRequest, schoolId: number): Promise<AxiosResponse<{data: SchoolSubscription}>> {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return await apiClient.post('/subscription/trials', request, {
      headers: {
        'X-School-ID': schoolId,
        Authorization: `Bearer ${user.access_token}`
      }
    });
  },

  // Subscription Management
  async getSchoolSubscription(): Promise<AxiosResponse<{data: SchoolSubscription}>> {
    return await apiClient.get(`subscriptions`);
  },

  async getSchoolTrialSubscription(): Promise<AxiosResponse<{data: SchoolSubscriptionResponse}>> {
    return await apiClient.get(`subscription/trials`);
  },

  async getSchoolUsage(): Promise<AxiosResponse<{data: SubscriptionUsage}>> {
    return await apiClient.get(`subscriptions/usage`);
  },

  async changePlan(request: PlanChangeRequest): Promise<AxiosResponse<{data: SchoolSubscription}>> {
    return await apiClient.post(`subscriptions/school/${request.schoolId}/plan/${request.newPlanId}/change`, {
      immediate: request.immediate || false
    });
  },

  async updateAutoRenew(request: AutoRenewRequest): Promise<AxiosResponse<{data: SchoolSubscription}>> {
    return await apiClient.put(`subscriptions/school/${request.schoolId}/subscription/${request.subscriptionId}/auto-renew`, {
      autoRenew: request.autoRenew
    });
  },

  async verifySubscriptionActivation(schoolId: string): Promise<AxiosResponse<{data: SchoolSubscription}>> {
    return await apiClient.get(`subscriptions/school/${schoolId}`);
  }
};
